import { X, ScrollText } from "lucide-react";
import { RELEASE_NOTES } from "@/lib/releaseNotes";
import { useScrollLock } from "@/lib/useScrollLock";

export default function ReleaseNotes({ onClose }) {
  useScrollLock(true);
  return (
    <div className="fixed inset-0 z-[120] flex items-end justify-center bg-black/60 p-0 backdrop-blur-md sm:items-center sm:p-4" data-testid="release-notes-modal" onClick={onClose}>
      <div className="w-full max-w-md rounded-t-3xl border border-slate-200 bg-white p-6 text-slate-900 shadow-2xl sm:rounded-3xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-brand-yellow to-brand-orange"><ScrollText className="h-4 w-4 text-black" strokeWidth={2.75} /></span>
          <h2 className="text-lg font-black tracking-tight">Update Logs</h2>
          <button onClick={onClose} data-testid="release-notes-close" aria-label="Close" className="ml-auto rounded-lg p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X className="h-5 w-5" /></button>
        </div>
        <div className="mt-4 max-h-[60vh] space-y-4 overflow-y-auto pr-1">
          {RELEASE_NOTES.map((r, i) => (
            <div key={i} data-testid={`release-note-${i}`} className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-black text-brand-orange">{r.version}</p>
                <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-slate-400">{r.date}</span>
              </div>
              <ul className="mt-2 space-y-1.5">
                {r.items.map((it, j) => (
                  <li key={j} className="flex gap-2 text-xs leading-relaxed text-slate-600"><span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-orange" />{it}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
